<div class="row">
  <span
    class="col-3 font-weight-bold text-right"
    i18n="@@server-boundage"
  >Serverbindung</span>
  <div class="col-6">
    <ng-select
      [items]="this.servers"
      [clearOnBackspace]="false"
      bindLabel="host"
      bindValue="_id"
      [(ngModel)]="this.room.serverId"
      (ngModelChange)="this.updateRoom.emit(this.room)"
    >
    </ng-select>
    <small
      class="form-text text-muted"
      i18n="@@server-boundage-desctiption"
    >Bis zum gewählten Datum läuft dieser Raum immer auf diesem Server.</small>
  </div>
  <div class="col-3">
    <input
      type="date"
      class="form-control"
      [(ngModel)]="this.serverIdExpDate"
      (ngModelChange)="this.onDateChange($event)"
    >
  </div>
</div>